import type { SocialPostPreviewCardMetadata } from '@wix/ai-scheduling-assistant-common-lib/entities';
import type { SocialPostRendition } from './social-post-preview-card';
import { postGridRenditions, type PostCaptionMarks } from './social-post-look-parts';

export const PINTEREST_TITLE_LIMIT = 100;
export const PINTEREST_DESCRIPTION_LIMIT = 250;
export const PINTEREST_UNMEASURED = 2 / 3;
export const PINTEREST_CAPTION_MARKS: PostCaptionMarks = { hashtags: true, mentions: false, urls: 'plain' };
export const PINTEREST_RENDITION: SocialPostRendition = { mode: 'fit', width: 660, height: 990 };
export const pinterestGridRendition = postGridRenditions(330, 334);

export type PinterestLook = 'pinterest';

export function pinterestLook(card: Pick<SocialPostPreviewCardMetadata, 'media'>): PinterestLook | undefined {
  return card.media.length > 0 ? 'pinterest' : undefined;
}
